/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_LabelInputs */

const en_us2_coach_mic_label = /** @type {(inputs: Coach_Mic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talk to your trainer`)
};

const pt_br2_coach_mic_label = /** @type {(inputs: Coach_Mic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falar com o personal`)
};

const es_419_coach_mic_label = /** @type {(inputs: Coach_Mic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hablar con el entrenador`)
};

const pt_pt2_coach_mic_label = /** @type {(inputs: Coach_Mic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falar com o treinador`)
};

const fr_fr2_coach_mic_label = /** @type {(inputs: Coach_Mic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parler à ton coach`)
};

const de_de2_coach_mic_label = /** @type {(inputs: Coach_Mic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit deinem Coach sprechen`)
};

const it_it2_coach_mic_label = /** @type {(inputs: Coach_Mic_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parla con il tuo coach`)
};

/**
* | output |
* | --- |
* | "Talk to your trainer" |
*
* @param {Coach_Mic_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_label = /** @type {((inputs?: Coach_Mic_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_label(inputs)
	if (locale === "es-419") return es_419_coach_mic_label(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_label(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_label(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_label(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_label(inputs)
	return en_us2_coach_mic_label(inputs)
});
export { coach_mic_label as "coach-mic.label" }